module.exports = __webpack_public_path__ + "img/img60_2.1ff2eac8.png";